export const TYPES = {
    header: 'header',
    body: 'body',
    small: 'small',
    span: 'span',
} as const;
declare type ValueOf<T> = T[keyof T];

export type Type = ValueOf<typeof TYPES>;

export const TAG_NAMES = {
    label: 'label',
    small: 'small',
    span: 'span',
    p: 'p',
    strikeout: 's',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
} as const;
export type TagName = ValueOf<typeof TAG_NAMES>;

export const COLORS = [
    'light',
    'regular',
    'strong',
    'attention',
    'white',
    'lighter',
    'inherit',
] as const;
export type Color = typeof COLORS[number];

export const WEIGHTS = {
    regular: 'regular',
    bold: 'bold',
} as const;
export type Weight = ValueOf<typeof WEIGHTS>;

export const HEADER_LEVELS = ['1', '2', '3', '4', '5', '6'] as const;
export type HeaderLevel = typeof HEADER_LEVELS[number];

export const SMALL_BODY_LEVELS = ['1', '2'] as const;
export type SmallBodyLevel = typeof SMALL_BODY_LEVELS[number];

export const LINE_HEIGHTS = ['paragraph', 'normal'] as const;
export type LineHeight = typeof LINE_HEIGHTS[number];

export const TRANSFORMS = ['uppercase', 'lowercase', 'capitalize', 'none'] as const;
export type Transform = typeof TRANSFORMS[number];

export const DEFAULT_TAG_NAME = {
    [TYPES.span]: TAG_NAMES.span,
    [TYPES.small]: TAG_NAMES.small,
    [TYPES.body]: TAG_NAMES.span,
} as const;

export const OVERFLOW_TYPE = ['ellipsis'] as const;
export type Overflow = typeof OVERFLOW_TYPE[number];

export const TEXT_DECORATION = ['underline'] as const;
export type TextDecoration = typeof TEXT_DECORATION[number];

export const UNDERLINE_OFFSET = ['auto', 'small', 'medium'] as const;
export type UnderlineOffset = typeof UNDERLINE_OFFSET[number];

export const STYLE = ['normal', 'italic'] as const;
export type Style = typeof STYLE[number];

export const HEADER_WEIGHTS: Record<HeaderLevel, Weight> = {
    1: 'regular',
    2: 'regular',
    3: 'bold',
    4: 'bold',
    5: 'bold',
    6: 'bold',
};
